// import request from '@/utils/request'
import request from '@/utils/microSeviceFormatRequest'

// export function getTutorAllScore () {
//   return request({
//     url: '/api/tutordata/TutorAllScore',
//     method: 'post'
//   })
// }

// QA test report
export function getEvaluateList () {
  return request({
    url: '/api/tutordata/EvaluateList',
    method: 'post'
  })
}
export function getTraiClass () {
  return request({
    timeout: 0,
    url: '/api/tutordata/TraiClass',
    method: 'post'
  })
}
// Top Tutor Ranking Board
export function getTopTutorRankingBoard () {
  return request({
    url: '/api/tutordata/TopTutorRankingBoard',
    method: 'post'
  })
}
export function getBulletinBoard () {
  return request({
    url: '/api/Message/BulletinBoard',
    method: 'post'
  })
}
//获取首页成长体系数据
export function getTutorHomeTask () {
  return request({
    url: '/api/GrowthSystem/GetTutorHomeTask',
    method: 'post'
  })
}
// 获取等级勋章数据
export function getGradeHonorDetail () {
  return request({
    url: '/api/GrowthSystem/GetGradeHonorDetail',
    method: 'post'
  })
}
// 特别成就勋章数据
// export function getMedalDetail () {
//   return request({
//     url: '/api/GrowthSystem/GetMedalDetail',
//     method: 'post'
//   })
// }
//获取成长体系积分
export function receivePoint (TaskCode) {
  return request({
    url: `/api/GrowthSystem/ReceivePoint?TaskCode=${TaskCode}`,
    method: 'post'
  })
}

//获取成长体系模块是否首次登录
export function growthSystemIsFirstLogin () {
  return request({
    url: '/api/GrowthSystem/GrowthSystemIsFirstLogin',
    method: 'post'
  })
}

//成长体系 做任务
export function growthSystemDoTask(TaskCode) {
  return request({
    url: `/api/GrowthSystem/DoTaskAsync?TaskCode=${TaskCode}`,
    method: 'post'
  })
}

// 积分明细 
export function getGrowthDetail (pageIndex,pageSize) {
  return request({
    url: '/api/GrowthSystem/GetGrowthDetail?pageIndex='+pageIndex+"&pageSize="+pageSize,
    method: 'post'
  })
}

// 进阶任务-课程学习-弹框
export function getCourseLearning () {
  return request({
    url: '/api/GrowthSystem/GetCourseLearning',
    method: 'post'
  })
}

// 进阶任务-课程学习-弹框订阅课程
export function subscriptionCourse (isCheckCourseTest,isCheckVideoTrain) {
  return request({
    url: '/api/GrowthSystem/SubscriptionCourse?isCheckCourseTest='+isCheckCourseTest+"&isCheckVideoTrain="+isCheckVideoTrain,
    method: 'post'
  })
}

// 获取成长积分排名
export function getGrowthPonitRanking (pageIndex,pageSize) {
  return request({
    url: '/api/GrowthSystem/GetGrowthPonitRanking?pageIndex='+pageIndex+"&pageSize="+pageSize,
    method: 'post'
  })
}

export function medalLog(code,type) {
    return request({
      url: `/api/GrowthSystem/TaskLog?code=${code}&type=${type}`,
      method: 'post'
    })
  }

// 获取老师积分排名
export function getTuGrowthRank () {
  return request({
    url: '/api/GrowthSystem/GetTuGrowthRank',
    method: 'post'
  })
}

// 领取特殊荣誉勋章
export function receviceMadal(MadalType) {
  return request({
    url: `/api/GrowthSystem/ReceviceMadal?MadalType=${MadalType}`,
    method: 'post'
  })
}

// 等级权益&荣誉权益
export function getTutorRights(level) {
  return request({
    url: `/api/GrowthSystem/GetTutorRights?level=${level}`,
    method: 'post'
  })
}

// 领取权益
export function receiveRights(rightsCode) {
  return request({
    url: `/api/GrowthSystem/ReceiveRights?rightsCode=${rightsCode}`,
    method: 'post'
  })
}

// 权益领取记录
export function tutorRightsRecode() {
  return request({
    url: `/api/GrowthSystem/TutorRightsRecode`,
    method: 'post'
  })
}

// growth system 新 
export function levelMedalList() {
  return request({
    url: `/api/GrowthSystem/LevelMedalList`,
    method: 'post'
  })
}
// 开启任务
export function taskStartSubmit() {
  return request({
    url: `/api/GrowthSystem/TaskStartSubmit`,
    method: 'post'
  })
}
//
export function getRightsList() {
  return request({
    url: `/api/GrowthSystem/GetRightsList`,
    method: 'post'
  })
}
//
export function getMilestoneList() {
  return request({
    url: `/api/GrowthSystem/GetMilestoneList`,
    method: 'post'
  })
}

export function getMilestoneDetail(type) {
  return request({
    url: `/api/GrowthSystem/GetMilestoneDetail?type=${type}`,
    method: 'post'
  })
}

export function isPassTL() {
  return request({
    url: `/api/GrowthSystem/IsPassTL`,
    method: 'post'
  })
}

export function getReceiveRecordToDay() {
  return request({
    url: `/api/GrowthSystem/GetReceiveRecordToDay`,
    method: 'post'
  })
}

export function getStrengthAssessment(isShowCycle,date) {
  return request({
    url: `/api/GrowthSystem/GetStrengthAssessment?isShowCycle=${isShowCycle}&date=${date}`,
    method: 'post'
  })
}

export function getScheduleList() {
  return request({
    url: `/api/GrowthSystem/GetScheduleList`,
    method: 'post'
  })
}

export function scheduleSubmit(data) {
  return request({
    url: `/api/GrowthSystem/ScheduleSubmit`,
    method: 'post',
    data
  })
}

export function getPetInfo() {
  return request({
    url: `/api/GrowthSystem/GetPetInfo`,
    method: 'post'
  })
}
export function adoptPet() {
  return request({
    url: `/api/GrowthSystem/AdoptPet`,
    method: 'post'
  })
}
export function getLimitedTimeMedal() {
  return request({
    url: `/api/GrowthSystem/GetLimitedTimeMedal`,
    method: 'post'
  })
}

export function alterPetName(petName) {
  return request({
    url: `/api/GrowthSystem/AlterPetName?petName=${petName}`,
    method: 'post'
  })
}

export function classGroupPhotoSubmit(data) {
  return request({
    url: `/api/GrowthSystem/ClassGroupPhotoSubmit`,
    method: 'post',
    data
  })
}

export function wearMedal(code) {
  return request({
    url: `/api/GrowthSystem/WearMedal?code=${code}`,
    method: 'post'
  })
}

export function getCertificationMedals() {
  return request({
    url: `/api/GrowthSystem/GetCertificationMedals`,
    method: 'post'
  })
}

export function requestLog(data) {
  return request({
    url: `/api/GrowthSystem/RequestLog`,
    method: 'post',
    data
  })
}

export function updateLogTime(data) {
  return request({
    url: `/api/GrowthSystem/UpdateLogTime`,
    method: 'post',
    data
  })
}

export function getPhotoSharing() {
  return request({
    url: `/api/GrowthSystem/GetPhotoSharing`,
    method: 'post'
  })
}

export function getGoalList() {
  return request({
    url: `/api/GrowthSystem/GetGoalList`,
    method: 'post'
  })
}

export function getGoalByRound() {
  return request({
    url: `/api/GrowthSystem/GetGoalByRound`,
    method: 'post'
  })
}

export function addGoal(data) {
  return request({
    url: `/api/GrowthSystem/AddGoal`,
    method: 'post',
    data
  })
}

export function deleteGoal(id) {
  return request({
    url: `/api/GrowthSystem/DeleteGoal?id=${id}`,
    method: 'post'
  })
}

export function updateGoal(id,target) {
  return request({
    url: `/api/GrowthSystem/UpdateGoal?id=${id}&target=${target}`,
    method: 'post'
  })
}

export function synchronizeGoalBasicWage(id) {
  return request({
    url: `/api/GrowthSystem/SynchronizeGoalBasicWage?id=${id}`,
    method: 'post'
  })
}

export function getReceiveByCourse() {
  return request({
    url: `/api/GrowthSystem/GetReceiveByCourse`,
    method: 'post'
  })
}

export function receivePointByCourse(id,type) {
  return request({
    url: `/api/GrowthSystem/ReceivePointByCourse?id=${id}&type=${type}`,
    method: 'post'
  })
}

// 根据等级获取宠物动图
export function getPetGifByLevel(level) {
  return request({
    url: `/api/GrowthSystem/GetPetGifByLevel?level=${level}`,
    method: 'post'
  })
}

// 获取老师已经拥有的皮肤
export function getTutorHaveSkin(level) {
  return request({
    url: `/api/GrowthSystem/GetTutorHaveSkin?level=${level}`,
    method: 'post'
  })
}

// 穿戴皮肤
export function wearPetClothing(id,isDefault) {
  return request({
    url: `/api/GrowthSystem/WearPetClothing?id=${id}&isDefault=${isDefault}`,
    method: 'post'
  })
}

// 领取皮肤
export function ReceivePetClothing(level) {
  return request({
    url: `/api/GrowthSystem/ReceivePetClothing?level=${level}`,
    method: 'post'
  })
}